import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import * as moment from "moment";
import { ConfigService } from 'src/app/services/config.service';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-signup-old',
  templateUrl: './signup-old.component.html',
  styleUrls: ['./signup-old.component.scss']
})
export class SignupOldComponent implements OnInit {

  countryCode: any = [];
  selectedCountryCode: any;
  url: string;
  public user :User = new User();
  now = new Date();
  minDate: string;

  constructor( private config: ConfigService, 
     private toasterService:ToasterService, public router:Router, private loginService:LoginService
  ) { 
    this.config.getLocalStorageData();
  }
  genderGroup = [
    {value:1, name:"Male"},
    {value:0, name:"Female"},
    {value:2, name:"Others"}
  ]

  ngOnInit() {
    this.getConuntryData();
    //this.user.gender = this.genderGroup[0].value;
    this.user.countryCode = this.selectedCountryCode;
    this.url = this.config.baseUrl + '/ImagePath/' + this.config._tid;
    /******user age - minimum 18 years for signup***/
    this.minDate = moment().subtract(6574, 'days').calendar();
    //console.log(this.minDate)
  }

  /*******To Remove Button 'Today' from the Calendar popup */
  customizeButtons(e) {
    let items = e.component.option("toolbarItems");
    items.shift();
    e.component.option("toolbarItems", items);
  }
  
/******* This Sets the Width of the select box dropdown - country code ***** */
  // onOpened(e) { 
  //   // console.log(e.component._popup.option) ;
  //   // setTimeout(function() { e.component.content().parent().width(175) }); 
  //   e.component._popup.option('width', 175);  
  // }

  onlyNumber(evt) {
    
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

   /**To get Country codes */
   getConuntryData() {
    this.loginService.getCountryCode(this.constructor.name).subscribe(result => {
      console.log(result)
      if(result['message'].code == 0){
        this.countryCode = result['data']['Country_MsT'];
        this.countryCode.forEach(element => {
          element.country_TEL_Code = '+' + element.country_TEL_Code.toString();
          if(element.country_Name == 'India' || element.country_Name == 'INDIA'){
            this.selectedCountryCode = element.Id ;
            this.user.countryCode = element.Id ;
          }
  
        })
      }else{
        this.toasterService.pop('error', result['message'].message)
      }
      console.log(this.countryCode)

    })

  }

  signUP(e){

    let result = e.validationGroup.validate();
    if(result.isValid){
      console.log(this.user);
      /**To Verify duplicate mobile number */
      this.loginService.verifyMobile(this.user.mobNumber, this.user.countryCode).subscribe(result => {
    
        if(result["message"].code == 1309){ //1039
          /**To Verify duplicate Email */
          this.loginService.verifyEmailId(this.user.email).subscribe(result => {
            if(result["message"].code == 8945 || result["message"].code == 401){
              let code = this.countryCode.filter(ele => {
                return ele.Id == this.user.countryCode
             })
            //  /*****Mobile Number with Country tel code with '+' sign*/
            //  this.user['userNumber'] = code[0].country_TEL_Code + this.user.mobNumber;
            //  /*****Mobile Number with Country tel code without '+' sign*/
            //  this.user['userMobile'] = code[0].country_NUM_Code + this.user.mobNumber;
             this.user['userFullName'] = this.user.firstName + ' ' + this.user.lastName;
             this.user.dob = this.user.dob ? moment(this.user.dob).format("YYYY-MM-DD") : null;
             this.user.anniversary = this.user.anniversary ? moment(this.user.anniversary).format("YYYY-MM-DD") : null;
             
              //console.log(code, this.user);
            localStorage.setItem("userData", JSON.stringify(this.user));
            // Need this to show on UI in Verify OTP page
            localStorage.setItem("countryTelCode", code[0].country_TEL_Code);
            this.router.navigate(['set-password'])
            }else if(result["code"] == 2002){
              this.toasterService.pop("error","Database connection not available at the moment!")
            }else{
              this.toasterService.pop("error", "This Email Id is already registered with us! Please try different one!");
            }
          })          
        }else if(result["message"].code == 3096 || result["message"].code == 2002){
          this.toasterService.pop("error", "Invalid country code!")
        }else{
          this.toasterService.pop("error", "This Mobile Number is already registered with us! Please try different one")
        }
      })
      
    }else{
      this.toasterService.pop('error', "Please Fill Required Fields!")
    }
  
  }

  disableTyping(e){
    e.preventDefault();
  }

}

export class User {
  public firstName : string = '';
  public lastName : string = '';
  public mobNumber : number = null;
  public countryCode : number = null;
  public email : string = '';
  public dob : any = null;
  public anniversary : any = null;
  public gender : any = null;
}
